/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_Col_NoteInputs */

const en_mk_sec_pg_ledger_col_note = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const id_mk_sec_pg_ledger_col_note = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keterangan`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Mk_Sec_Pg_Ledger_Col_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_col_note = /** @type {((inputs?: Mk_Sec_Pg_Ledger_Col_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_Col_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_col_note(inputs)
	return en_mk_sec_pg_ledger_col_note(inputs)
});